package com.parmartechnologies.core.feature.payment.network

import com.parmartechnologies.core.feature.product.model.ProductPrice
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class CreatePaymentRequest @OptIn(ExperimentalTime::class) constructor(
    @SerialName("payment_id") var paymentId: Long = Clock.System.now().epochSeconds,
    @SerialName("user_id") var UserID: String = "",
    @SerialName("mobile_number") var mobile: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("selected_business_id") var selectedBusinessID: String = "",
    @SerialName("address_id") var addressID: String = "",
    @SerialName("device_id") var deviceId: String = "",
    @SerialName("pricing") var pricing: ProductPrice? = null,
    @SerialName("PaymentGatewayName") var paymentGateway: String = "",
    @SerialName("DeliveryType") var deliveryType: String = "",
    @SerialName("instant_discount") var instantDiscount: Double = 0.0,
    @SerialName("coupon") var coupon: Double = 0.0,
)

@Serializable
data class RetrievePaymentRequest(
    @SerialName("_id") var _id: String = "",
)

@Serializable
data class FindPaymentRequest(
    @SerialName("_id") var _id: String = "",
)